import { WithdrawalsExchangeRatesRecord } from '@types';

import { WithdrawalsSetExchangeRateAmountReducer } from './types';

export const withdrawalsSetExchangeRateAmountReducer: WithdrawalsSetExchangeRateAmountReducer =
  (state, action) => {
    const { id, rateAmount } = action.payload;

    const exchangeRateToUpdate =
      state.withdrawalsExchangeRatesProcessedItems?.[id];

    if (!exchangeRateToUpdate) {
      return state;
    }

    const updatedItem: WithdrawalsExchangeRatesRecord = {
      [id]: {
        ...exchangeRateToUpdate,
        exchangeRate: rateAmount,
      },
    };

    return {
      ...state,
      withdrawalsExchangeRatesProcessedItems: {
        ...state.withdrawalsExchangeRatesProcessedItems,
        ...updatedItem,
      },
    };
  };
